import { type VariantProps, cva } from "cva";

import { cn } from "~/components/ui/cn";

const orderBadgeVariants = cva({
  base: "inline-flex items-center rounded-[3px] text-sm",
  variants: {
    variant: {
      default: "",
      filled: "px-2 py-1",
      warning: "bg-orange-300 px-2 py-1 font-semibold text-orange-600",
      danger: "bg-red-300 px-2 py-1 font-semibold text-red-600",
    },
    intent: {
      default: "",
      bold: "",
    },
  },
  compoundVariants: [
    {
      variant: ["default", "filled"],
      intent: "default",
      className: "text-[#767A7C]",
    },
    {
      variant: ["default", "filled"],
      intent: "bold",
      className: "text-gray-700",
    },
    {
      variant: "filled",
      intent: "default",
      className: "bg-gray-100",
    },
    {
      variant: "filled",
      intent: "bold",
      className: "bg-gray-50",
    },
  ],
  defaultVariants: {
    variant: "default",
    intent: "default",
  },
});

export type OrderBadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof orderBadgeVariants>;

export const OrderBadge: React.FC<OrderBadgeProps> = ({
  className,
  children,
  intent,
  variant,
  ...props
}: OrderBadgeProps) => {
  return (
    <div
      className={cn(orderBadgeVariants({ variant, intent }), className)}
      {...props}
    >
      {children}
    </div>
  );
};
